import { Grid, Tooltip } from "@mui/material";
import { Icon } from "components/common";
import { StyleEnums } from "models/enums";
import { WintSalaryPaymentStatusProps } from "models/propTypes/wintSalaryPropTypes";
import React from "react";
import cssExports from "theme/styles/main.module.scss";
import { IconDefinitionConstants } from "utils/constants";
import { LocalizationHelperInstance } from "utils/helpers";
import { WintSuperkollAPIModelWintSalaryReport } from "wint-api-client/dist/types";

const WintSalaryPaymentStatus: React.FC<WintSalaryPaymentStatusProps> = (props) => {
  const { state } = props;

  const getSalaryPaymentStateText = (state: WintSuperkollAPIModelWintSalaryReport.SalaryPaymentState) => {
    return LocalizationHelperInstance.getTranslatedEnumValue("Salary.SalaryPaymentState", state);
  };

  const getSalaryPaymentStateIcon = (state: WintSuperkollAPIModelWintSalaryReport.SalaryPaymentState) => {
    switch (state) {
      case WintSuperkollAPIModelWintSalaryReport.SalaryPaymentState.Unknown:
        return { icon: IconDefinitionConstants.WValidateUnknown, type: StyleEnums.DisplayType.None };
      case WintSuperkollAPIModelWintSalaryReport.SalaryPaymentState.NotPaid:
        return { icon: undefined, type: undefined };
      case WintSuperkollAPIModelWintSalaryReport.SalaryPaymentState.PartiallyPaid:
        return { icon: IconDefinitionConstants.WValidateCheck, type: StyleEnums.DisplayType.Warning };
      case WintSuperkollAPIModelWintSalaryReport.SalaryPaymentState.PaymentInProcess:
        return { icon: IconDefinitionConstants.WArrowSmallRight, type: StyleEnums.DisplayType.Info };
      case WintSuperkollAPIModelWintSalaryReport.SalaryPaymentState.SentToBank:
        return { icon: IconDefinitionConstants.WArrowSmallRight, type: StyleEnums.DisplayType.Info };
      case WintSuperkollAPIModelWintSalaryReport.SalaryPaymentState.Paid:
        return { icon: IconDefinitionConstants.WValidateCheck, type: StyleEnums.DisplayType.Success };
      case WintSuperkollAPIModelWintSalaryReport.SalaryPaymentState.NoPayment:
        return { icon: IconDefinitionConstants.WValidateCheck, type: StyleEnums.DisplayType.Success };
      case WintSuperkollAPIModelWintSalaryReport.SalaryPaymentState.CancelledByBank:
        return { icon: IconDefinitionConstants.WTimesThin, type: StyleEnums.DisplayType.Danger };
      // Same failed-payout affordance as CancelledByBank — only the wording differs, since this
      // one never reached a bank (DEV-27833). Without this case the default arm returns no icon
      // and the component renders nothing at all, silently hiding the failure.
      case WintSuperkollAPIModelWintSalaryReport.SalaryPaymentState.PayoutFailed:
        return { icon: IconDefinitionConstants.WTimesThin, type: StyleEnums.DisplayType.Danger };
      case WintSuperkollAPIModelWintSalaryReport.SalaryPaymentState.WithdrawnFromCompanyAccount:
        return { icon: IconDefinitionConstants.WArrowSmallRight, type: StyleEnums.DisplayType.Info };
      default:
        return { icon: undefined, type: undefined };
    }
  };

  const paymentValues = getSalaryPaymentStateIcon(state);

  return paymentValues.icon ? (
    <Tooltip
      disableInteractive
      placement="top"
      title={getSalaryPaymentStateText(state)}
      classes={{ tooltip: cssExports.tooltip, popper: cssExports.tooltipPopper }}
    >
      <Grid item>
        <Icon icon={paymentValues.icon} className={cssExports.tableIcon} displayType={paymentValues.type} />
      </Grid>
    </Tooltip>
  ) : (
    <></>
  );
};

export default WintSalaryPaymentStatus;
